import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

export default function LegalPageLayout({ title, date, sections, testId }) {
  return (
    <div className="min-h-screen bg-[#0A0A0A]" data-testid={testId}>
      {/* Hero */}
      <div className="relative pt-28 sm:pt-36 pb-16 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-zinc-900/30 to-[#0A0A0A]" />
        <div className="absolute top-20 left-1/3 w-80 h-80 rounded-full bg-violet-600/[0.04] blur-[120px] pointer-events-none" />

        <div className="max-w-4xl mx-auto px-6 lg:px-12 relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-white transition-colors mb-10">
              <ArrowLeft className="w-4 h-4" />
              Ana Sayfa
            </Link>

            <div className="flex items-center gap-4 mb-4">
              <div className="w-10 h-10 rounded-xl bg-zinc-800/80 border border-zinc-700/50 flex items-center justify-center">
                <FileText className="w-5 h-5 text-zinc-400" />
              </div>
              <span className="text-xs font-mono text-zinc-600 tracking-widest uppercase">{date}</span>
            </div>

            <h1 className="text-3xl sm:text-4xl font-bold text-white tracking-tight">{title}</h1>
          </motion.div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 lg:px-12 pb-24">
        <div className="space-y-5">
          {sections.map((section, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.4, delay: index * 0.03 }}
            >
              <div className="p-6 lg:p-8 rounded-2xl border border-zinc-800/40 bg-zinc-900/30 backdrop-blur-sm hover:border-zinc-800/60 transition-colors duration-300">
                <div className="flex items-start gap-4">
                  <span className="text-2xl font-black text-zinc-800/40 leading-none select-none w-8 flex-shrink-0 pt-0.5">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <div className="flex-1 min-w-0">
                    <h2 className="text-base font-bold text-white mb-3 tracking-tight">{section.title}</h2>
                    <div className="text-zinc-400 text-sm leading-[1.8] space-y-3">
                      {section.content}
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
